import { Link as RouterLink, Outlet, useLocation, useNavigate } from "react-router-dom";
import Tab, { TabProps } from '@mui/material/Tab';
import { IconButton, Tooltip, Typography } from '@mui/material';
import BookmarkAddIcon from '@mui/icons-material/BookmarkAdd';
import { TabsStyled } from "./Tabs.styled";
import { useTheme } from "@emotion/react";
import { TicketRoute } from "../../models/types";
import ReturnButton from "../../components/return-button/ReturnButton";
import { StyledTickets } from "./Tickets.styled";
import { TicketHebType } from "../../models/types";


interface LinkTabProps extends TabProps {
  path: string;
  selected?: string
}


function LinkTab(props: LinkTabProps) {

  const theme = useTheme();

  return (
    <Tab
      component={RouterLink}
      to={props.path}
      label={props.label}
      aria-current={props.selected ? 'page' : undefined}
      {...props}
      sx={{
        color: theme.colors.main_color, // Use theme colors dynamically
      }}
    />
  );
}

type Tab = {
  label: string,
  type: TicketHebType,
  url: TicketRoute,
}

// Define an array of tab hrefs
const tabsData: Tab[] = [
  {
    label: "לקוחות/ספקים",
    type: "לקוח-ספק",
    url: "customers",
  },
  {
    label: "פריטים/מלאי",
    type: "פריט",
    url: "items",
  },
  {
    label: "קודי עבודה",
    type: "עבודה",
    url: "works",
  },
  {
    label: "רכבים",
    type: "רכב",
    url: "cars",
  },
  {
    label: "הכנסות",
    type: "הכנסה",
    url: "incomes",
  },
  {
    label: "הוצאות",
    type: "הוצאה",
    url: "outcomes",
  },
  {
    label: "בנק",
    type: "בנק",
    url: "banks",
  },
  {
    label: "קופה",
    type: "קופה",
    url: "cash-boxes",
  },
  {
    label: "מערכת",
    type: "מערכת",
    url: "system",
  },

];


function Tickets() {
  
  const location = useLocation();
  const navigate = useNavigate();
  const theme = useTheme();

  const currentIndex = tabsData.findIndex(tab => `/${tab.url}` === location.pathname);
  const value = currentIndex !== -1 ? currentIndex : 0;



  function addTicket(): void {
    navigate(`${location.pathname}/add`);
    // navigate(`${location.pathname}/add`, {
    //   replace: true,
    //   state: {
    //       breadcrumbData: [
    //           {
    //             name: "כרטסות",
    //           },
    //           {
    //             name: tabsData[currentIndex].label,
    //             link: `/${tabsData[currentIndex].url}`
    //           },
    //           {
    //             name: `הוספת כרטיס`
    //           }
    //       ]
    //   }}
    // );
  }


  return (
    <StyledTickets>
      <Typography variant="h5" component="span">
        דפדוף בכרטסות
      </Typography>

      {/* <button onClick={addTicket}>+ הוספת כרטיס</button> */}
      <Tooltip title="הוספת כרטיס">
        <IconButton onClick={addTicket} sx={{ color: theme.colors.main_color }}>
          <BookmarkAddIcon />
        </IconButton>
      </Tooltip>

      <TabsStyled
        dir='ltr'
        value={value}
        //textColor="secondary"
        //indicatorColor="secondary"
        role="navigation"
        variant="scrollable"
        scrollButtons
        allowScrollButtonsMobile
        aria-label="scrollable force tabs example"
        style={{ direction: "rtl", flexDirection: "row-reverse", padding: 5, marginTop: 20 }}

      >
        {tabsData.map((tab, index) => (
          <LinkTab key={index} label={tab.label} path={tab.url} />
        ))}
      </TabsStyled>
      <Outlet />

      <div className="buttons">
        <ReturnButton/>
      </div>
      
    </StyledTickets>
  );
}

export default Tickets;